let lastKnownScrollPosition = 0;
let ticking = false;

function setScrollCustomProperty(position) {
	let percentage = Math.ceil((position / (document.documentElement.scrollHeight - window.innerHeight)) * 100);
	document.documentElement.style.setProperty("--scroll-progress", percentage + "%");
}

document.addEventListener("scroll", function (event) {
	lastKnownScrollPosition = window.scrollY;

	if (!ticking) {
		window.requestAnimationFrame(() => {
			setScrollCustomProperty(lastKnownScrollPosition);
			ticking = false;
		});

		ticking = true;
	}
});

document.addEventListener("DOMContentLoaded", function (event) {
	setScrollCustomProperty(window.scrollY);
});
